import { FC, useState } from 'react';
import { TextField, Typography } from '@mui/material';
import { useUpdateTaskTitleMutation } from 'redux/apiSlices/tasks.slice';

const TaskTitle: FC<{
  title: string;
  taskId: string;
  wrap?: boolean;
}> = ({ title, taskId, wrap }) => {
  const [editMode, setEditMode] = useState(false);
  const [inputValue, setInputValue] = useState(title);
  const [updateTitle] = useUpdateTaskTitleMutation();

  const openEditMode = () => {
    setEditMode(true);
  };
  const closeEditMode = () => {
    setEditMode(false);
  };

  const onUpdateTitle = async () => {
    const newTitle = inputValue.trim();
    if (newTitle === title || !newTitle) {
      closeEditMode();
      setInputValue(title);
    } else {
      await updateTitle({
        title: newTitle,
        taskId,
      });
      closeEditMode();
    }
  };

  return editMode ? (
    <TextField
      size="small"
      fullWidth
      value={inputValue}
      onChange={e => {
        setInputValue(e.target.value);
      }}
      autoFocus
      onBlur={onUpdateTitle}
      onKeyDown={async event => {
        if (event.key === 'Enter') {
          await onUpdateTitle();
        }
      }}
      sx={{
        '& .MuiInputBase-input': {
          fontSize: '1.25rem',
          fontWeight: 600,
          py: 0.5,
        },
      }}
    />
  ) : (
    <Typography
      variant="h5"
      onClick={openEditMode}
      sx={{
        fontWeight: 600,
        color: 'text.primary',
        cursor: 'pointer',
        wordBreak: 'break-word',
        '&:hover': {
          color: 'primary.main',
        },
        ...(wrap
          ? {}
          : {
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }),
      }}
    >
      {title}
    </Typography>
  );
};

export default TaskTitle;
